/**
 * The two per-tab representations of whichever brand is currently applied —
 * the favicon and the document title — shared by `useBrand` (pre-auth,
 * hostname-resolved) and `useMyBrand` (authenticated, tenant-resolved) so a
 * partner's tenants see their own tab icon and name before *and* after
 * sign-in, not just once they're in.
 */

/** The static, app-wide favicon declared in index.html — restored whenever no
 * per-tenant/partner logo is configured (or once signed out). */
export const DEFAULT_FAVICON = '/brand/abc.jpeg';

/** The static, app-wide title declared in index.html — restored the same way. */
export const DEFAULT_TITLE = 'Docsight';

export function applyFavicon(url: string | null): void {
  let link = document.querySelector<HTMLLinkElement>('link[rel="icon"]');
  if (link === null) {
    link = document.createElement('link');
    link.rel = 'icon';
    document.head.appendChild(link);
  }
  link.href = url ?? DEFAULT_FAVICON;
}

export function applyTitle(productName: string | null): void {
  document.title = productName ?? DEFAULT_TITLE;
}
